import { createRouter, createWebHistory } from 'vue-router'
import { useCommonStore } from '@/stores/common'
import editorRouter from '@/router/editor.ts'
import signRouter from './sign'
import assetRouter from './asset'
import templateRouter from './template'
import adminRouter from './admin.ts'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			children: [
				{
					path: '',
					redirect: '/dashboard',
				},
				{
					path: '/not-found',
					name: 'NotFound',
					component: () => import('../template/BasicTemplate.vue'),
				},
				{
					path: '/dashboard',
					name: 'Dashboard',
					component: () => import('../template/BasicTemplate.vue'),
				},
				...signRouter,
				...editorRouter,
				...templateRouter,
				...assetRouter,
				...adminRouter,
			],
		},
		// catch-all은 최하단(top-level)에서 처리해야 '/'까지 먹는 이슈가 없다.
		{
			path: '/:pathMatch(.*)*',
			name: 'Error',
			redirect: '/not-found',
		},
	],
})

router.beforeEach((to, from) => {
	// 로그인 페이지로 진입하면 인증 관련 로컬스토리지만 초기화
	// - savedId(아이디 저장)와 lang(언어 설정)은 유지
	// - clear() 대신 특정 키만 삭제하여 안전성 향상
	if (to.name === 'SignIn') {
		// [HOTFIX] userAuth 포함 — stores/common.ts, Info.vue 주석 참고
		// 문제 발생 시 'userAuth'만 목록에서 제거하고 stores/common.ts·Info.vue의 같은 주석 블록도 함께 원복할 것
		const keysToRemove = [
			'accessToken',
			'refreshToken',
			'userId',
			'userName',
			'tabList',
			'noteUid',
			'activeTab',
			'DLT',
			'userAuth'
		]
		
		keysToRemove.forEach(key => {
			localStorage.removeItem(key)
		})
		
		// 사용자별 키(tabList:*, noteUid:*) 패턴 기반 삭제
		Object.keys(localStorage).forEach(key => {
			if (key.startsWith('tabList:') || key.startsWith('noteUid:')) {
				localStorage.removeItem(key)
			}
		})
		
		return true
	}

	const isAuthenticated = localStorage.getItem('accessToken')

	if (!isAuthenticated && to.name !== 'SignIn') {
		localStorage.removeItem('accessToken')
		return { name: 'SignIn' }
	}

	if (to.matched.some(record => record.meta.requiresAdmin)) {
		const commonStore = useCommonStore()
		if (!commonStore.userInfo.auth.admin) {
			return { name: 'Dashboard' }
		}
	}
})

router.onError((error, to) => {
	const isChunkLoadError =
		error.message?.includes('Failed to fetch dynamically imported module') ||
		error.message?.includes('Importing a module script failed') ||
		error.message?.includes('error loading dynamically imported module') ||
		error.name === 'ChunkLoadError'

	if (isChunkLoadError) {
		const targetPath = to?.fullPath || window.location.pathname
		window.location.href = targetPath
	}
})

export default router
